import React from 'react'
import { Paper, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { useTheme, Theme } from '@mui/material/styles'
import useOpportunityFormRequirements from 'hooks/useOpportunityFormRequirements'
import { Cancel } from '@mui/icons-material'

function RequiredFieldsTooltip(): JSX.Element {
  const theme: Theme = useTheme()
  const {
    warehouseCityPresent,
    warehouseStatePresent,
    warehouseDateStartPresent,
    warehouseDateEndPresent,
    warehouseSpaceNeededMinPresent,
    warehouseSpaceNeededMaxPresent,
    warehouseMonthToMonthPresent,
  } = useOpportunityFormRequirements()

  const requiredFields: { label: string; present: boolean }[] = warehouseMonthToMonthPresent
    ? [
        {
          label: 'ADDRESS (City, State)',
          present: warehouseCityPresent && warehouseStatePresent,
        },
        { label: 'DATE START', present: warehouseDateStartPresent },
        {
          label: 'SPACE NEEDED (Min, Max or Both)',
          present: warehouseSpaceNeededMinPresent || warehouseSpaceNeededMaxPresent,
        },
      ]
    : [
        {
          label: 'ADDRESS (City, State)',
          present: warehouseCityPresent && warehouseStatePresent,
        },
        { label: 'DATE START', present: warehouseDateStartPresent },
        { label: 'DATE END', present: warehouseDateEndPresent },
        {
          label: 'SPACE NEEDED (Min, Max or Both)',
          present: warehouseSpaceNeededMinPresent || warehouseSpaceNeededMaxPresent,
        },
      ]

  return (
    <Paper
      elevation={2}
      sx={{
        p: 2,
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        bgcolor: theme.palette.grey[50],
        color: theme.palette.text.primary,
        maxWidth: 360,
      }}
    >
      <Typography variant="h6" gutterBottom>
        Required Fields
      </Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>
        These fields are required to generate a warehouse solution:
      </Typography>
      <List dense>
        {requiredFields.map(({ label, present }) => (
          <ListItem key={label}>
            <ListItemIcon>
              {present ? <CheckCircleIcon color="success" /> : <Cancel color="error" />}
            </ListItemIcon>
            <ListItemText primary={label} />
          </ListItem>
        ))}
      </List>
    </Paper>
  )
}

export default RequiredFieldsTooltip
